type DuplicateComparable = {
  name: string;
  content: string;
  size: number;
};

function normalizeText(value: string) {
  return value.trim().replace(/\s+/g, ' ').toLowerCase();
}

export function areDocumentsDuplicate(
  existing: DuplicateComparable,
  incoming: DuplicateComparable,
) {
  const sameNameAndSize = normalizeText(existing.name) === normalizeText(incoming.name) && existing.size === incoming.size;
  if (sameNameAndSize) {
    return true;
  }

  return normalizeText(existing.content) === normalizeText(incoming.content);
}

export function findDuplicateDocument(
  existingDocuments: DuplicateComparable[],
  incoming: DuplicateComparable,
) {
  return existingDocuments.find((document) => areDocumentsDuplicate(document, incoming)) ?? null;
}